// ** React Imports
import { useEffect } from "react";

// ** Next Imports
import { useNavigate, useLocation } from "react-router-dom";

// ** Config
import authConfig from "src/configs/auth";

// ** React-Redux
import { useSelector } from "react-redux";

const AuthGuard = (props) => {
  const { children, fallback } = props;

  const { user, loading } = useSelector((state) => state.auth);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(
    () => {
      const currentPath = location.pathname + location.search + location.hash;
      if (
        user === null &&
        !window.localStorage.getItem(authConfig.storageUserDataKeyName)
      ) {
        if (currentPath !== "/login") {
          navigate(`/login?redirect=${currentPath}`);
        } else {
          navigate("/login");
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  if (loading || user === null) {
    return fallback;
  }

  return children;
};

export default AuthGuard;
